import { ColDef, ColGroupDef, GridApi } from 'ag-grid-community';

const isColDef = (def: ColDef | ColGroupDef): def is ColDef => {
  return 'colId' in def;
};

/**
 * Applies the Manage Columns selection: the given colIds become the visible columns,
 * in that order, and every other column is hidden after them.
 *
 * The order goes through `applyColumnState` rather than the order of a replacement
 * `columnDefs` array. This grid sets `maintainColumnOrder`, so ag-grid restores the
 * previous display order on any colDefs replacement and ignores the array order.
 */
export function setColumnOrderAndVisibility(newVisibleColumnsOrder: string[], gridApi: GridApi | null) {
  if (!gridApi) {
    return;
  }

  const allColIds = (gridApi.getColumnDefs() ?? [])
    .filter(isColDef)
    .flatMap((def) => (def.colId ? [def.colId] : []));
  const known = new Set(allColIds);
  const selected = new Set(newVisibleColumnsOrder);

  gridApi.applyColumnState({
    state: [
      ...newVisibleColumnsOrder.filter((colId) => known.has(colId)).map((colId) => ({ colId, hide: false })),
      // Parked after the visible block, so re-selecting one appends it.
      ...allColIds.filter((colId) => !selected.has(colId)).map((colId) => ({ colId, hide: true })),
    ],
    applyOrder: true,
  });
}
